import { Link, Outlet, useLocation } from 'react-router-dom';
import { getShortAthleteId } from '../lib/result_utils';

import AWSPatriotsLogo from '../../assets/AWS_Patriots_Lockup_onDark.png';

export function AppShell() {
  const { pathname, search } = useLocation();
  const isHomePage = pathname === '/';
  const leaderboardAthleteId =
    pathname === '/leaderboard'
      ? new URLSearchParams(search).get('athleteId')?.trim()
      : undefined;
  const headerAction = leaderboardAthleteId
    ? {
        label: 'View my data',
        to: `/athletes/${encodeURIComponent(getShortAthleteId(leaderboardAthleteId))}`,
      }
    : {
        label: 'Home',
        to: '/',
      };

  return (
    <div className="mx-auto min-h-screen w-full bg-aws-cloud shadow-2xl">
      <a
        href="#main-content"
        className="button-primary fixed left-3 top-3 z-50 -translate-y-24 px-4 py-3 font-bold focus:translate-y-0"
      >
        Skip to content
      </a>
      <header className="relative z-10 flex h-14 items-center justify-between gap-3 border-b border-white/10 bg-qs-navy px-4 text-white shadow-lg shadow-indigo-950/15">
        <Link to="/" aria-label="Patriots Creator Combine home" className="flex items-center gap-4 font-black p-0">
          <img
            src={AWSPatriotsLogo}
            alt="AWS Patriots"
            className="h-10 object-contain"
          />
          <span className="text-md font-black tracking-tight text-white">Patriots Creator Combine</span>
        </Link>
        {!isHomePage && (
          <Link
            to={headerAction.to}
            className="inline-flex min-h-10 items-center rounded-lg border border-white/20 bg-white/10 px-4 py-2 text-sm font-black text-white transition hover:bg-white/20 active:scale-[0.97] active:bg-white/25"
          >
            {headerAction.label}
          </Link>
        )}
      </header>
      <main id="main-content" className="min-h-[calc(100dvh-3.5rem)]">
        <Outlet />
      </main>
    </div>
  );
}
